/**
 * The name used in a greeting: "Dr. Avery Lane" -> "Dr. Lane", "Kim Rivera" -> "Kim".
 * A bare first token such as "Dr." is never used on its own.
 */
export function greetingName(displayName: string): string {
  // "Dr. Dana Dentist (Test)" -> "Dr. Dentist": a bracketed tag is not a name.
  const parts = displayName
    .replace(/\([^)]*\)/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return displayName.trim();
  if (/^dr\.?$/i.test(parts[0] ?? '') && parts.length > 1) return `Dr. ${parts[parts.length - 1]}`;
  return parts[0] ?? displayName;
}
